// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GuidEventLookupListResultModel from '../../model/guid-event-lookup-list-result-model';
import GuidEventLookupListResultDTO from '../dto/guid-event-lookup-list-result-dto';
import dtoSchema from '../schemas/guid-event-lookup-list-result-schema';
import GuidEventLookupModel from '../../model/guid-event-lookup-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class GuidEventLookupListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GuidEventLookupListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => GuidEventLookupModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: GuidEventLookupModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<GuidEventLookupListResultDTO>): GuidEventLookupListResultModel;
  static toModel(dto: DeepPartial<GuidEventLookupListResultDTO> | undefined | null): GuidEventLookupListResultModel | undefined;
  static toModel(dto: DeepPartial<GuidEventLookupListResultDTO> | undefined | null): GuidEventLookupListResultModel | undefined {
    return dto ? new GuidEventLookupListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GuidEventLookupListResultModel> | GuidEventLookupListResultModel): GuidEventLookupListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as GuidEventLookupListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GuidEventLookupListResultModel, can not map to GuidEventLookupListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
